<template>
  <div class="fromBox">
    <div class="box">
      <div class="formHeader">
        <div></div>
        <div>订单编号</div>
        <div>数量</div>
        <div>文件</div>
        <div>价格</div>
        <div>下单时间</div>
        <div>订单状态</div>
        <div>操作</div>
      </div>
      <div class="font" v-if="list.length == 0">暂无数据</div>
      <div v-else v-for="(item, index) in list" :key="index" class="flexBox">
        <div>
          <img src="../../assets/imges/prologo1.png" alt="" />
        </div>
        <div>{{ item.OrderNo }}</div>
        <div>{{ JSON.parse(item.OrderGoodsDtos[0].Content).Det_Num }}</div>
        <div style="display: flex; flex-wrap: wrap">{{ item.Model }}</div>
        <div>￥{{ item.Amount }}</div>
        <div>{{ item.CreatedTime }}</div>
        <div>
          <div v-if="item.State == 1">待审核</div>
          <div v-if="item.State == 2">待付款</div>
          <div v-if="item.State == 3">生产中</div>
          <div v-if="item.State == 4">待发货</div>
          <div v-if="item.State == 5">待收货</div>
          <div v-if="item.State == 6">待评价</div>
          <div v-if="item.State == 7">已完成</div>
          <div v-if="item.State == 8">退款中</div>
          <div v-if="item.State == 9">已拒绝</div>
          <div v-if="item.State == 10">已取消</div>
          <div v-if="item.State == 11">审核取消</div>
        </div>
        <div class="flexox" style="font-size: 00.8rem">
          <span
            v-if="item.State == 2"
            @click="orderLisr(item)"
            style="color: #f00"
            >支付</span
          >
          <span
            v-if="item.State == 3"
            @click="getProgress(item)"
            style="color: #12a182"
            >订单进度</span
          >
          <span
            v-if="item.State == 5"
            @click="orderProgress(item)"
            style="color: #12a182"
            >查看物流</span
          >
          <span v-if="item.State == 5" @click="returnGoos" style="color: #f00"
            >退货</span
          >
          <span
            v-if="item.State == 5"
            @click="ConfirmGoods(item)"
            style="color: #409eff"
            >确认收货</span
          >
          <span
            v-if="item.State == 7"
            @click="singleOrder(item)"
            style="color: #f00"
            >返单</span
          >
          <span @click="detailsOrde(item)">详情</span>
          <span
            v-if="item.State == 6"
            @click="orderEvaluation(item)"
            style="color: #f00"
            >评价</span
          >
          <el-popconfirm
            v-if="item.State == 1 || item.State == 11 || item.State == 2"
            @confirm="confirm(item.Id)"
            title="您确定取消这条订单吗?"
          >
            <span slot="reference">取消订单</span>
          </el-popconfirm>
        </div>
      </div>
    </div>
    <!-- 确认订单 -->
    <el-dialog
      title="确认订单"
      :visible.sync="MakeOrder"
      width="40%"
      :before-close="handleClose"
    >
      <div>
        <div class="box">
          <div>
            {{ orderItem.Consignee }} -<span>{{ orderItem.Phone }}</span>
          </div>
          <div>{{ orderItem.Address }}</div>
        </div>
        <div class="details">
          <div>
            <div>交货尺寸:</div>
            <div>
              {{ Content.Det_BoardSize_W }}*{{ Content.Det_BoardSiez_H }}
            </div>
          </div>
          <div>
            <div>交货数量:</div>
            <div>{{ Content.Det_Num }}pcs</div>
          </div>
          <div>
            <div>set数:</div>
            <div>{{ Content.set }}</div>
          </div>
          <div>
            <div>下单型号:</div>
            <div>{{ orderItem.Model }}</div>
          </div>
          <div>
            <div>面积:</div>
            <div>{{ Content.Area }}平方米</div>
          </div>
          <div>
            <div>拼板款数:</div>
            <div>{{ Content.Det_Pmodels }}</div>
          </div>
          <div>
            <div>板材类型:</div>
            <div>{{ Content.Det_BoardType }}</div>
          </div>
          <div>
            <div>板材供应商:</div>
            <div>{{ Content.Det_BoardSupplier }}</div>
          </div>
          <div>
            <div>成品外层铜厚:</div>
            <div>{{ Content.Det_Copper_out }}oz</div>
          </div>
          <div>
            <div>阻焊颜色:</div>
            <div>{{ Content.Det_ZHcolor }}</div>
          </div>
          <div>
            <div>阻焊覆盖:</div>
            <div>{{ Content.coverText }}</div>
          </div>
          <div>
            <div>表面处理:</div>
            <div>{{ Content.Det_Surface }}</div>
          </div>
          <div>
            <div>测试:</div>
            <div>{{ Content.Det_TestMethod }}</div>
          </div>
          <div>
            <div>确认生产稿:</div>
            <div>{{ Content.draftText }}</div>
          </div>
          <div>
            <div>最小线宽/线距:</div>
            <div>{{ Content.Det_LineSpacing }}mil</div>
          </div>
          <div>
            <div>最小孔径:</div>
            <div>{{ Content.aperture }}</div>
          </div>
          <div>
            <div>成型方式:</div>
            <div>{{ Content.Det_MouldManner }}</div>
          </div>
          <div>
            <div>订单号/物料编号:</div>
            <div>{{ Content.TorderNo }}</div>
          </div>
          <div>
            <div>收据/送货单:</div>
            <div>{{ Content.receiptText }}</div>
          </div>
          <div>
            <div>接受打叉板:</div>
            <div>{{ Content.isBreakBoard == 1 ? "接受" : "不接受" }}</div>
          </div>
          <div>
            <div>特殊工艺:</div>
            <div>
              {{ Content.Det_IsHalfHole == 0 ? "" : "半孔"
              }}{{ Content.Det_IsBGA == 0 ? "" : "BGA"
              }}{{ Content.Det_IsImp == 0 ? "" : "阻抗" }}
            </div>
          </div>
          <div>
            <div>接受标准:</div>
            <div>{{ Content.standardText }}</div>
          </div>
          <div>
            <div>发票信息:</div>
            <div>{{ Content.invoiceText }}</div>
          </div>
        </div>
        <div style="display: flex; margin-top: 1rem">
          <div style="width: 20%">优惠券:</div>
          <el-select
            style="width: 80%"
            v-model="region"
            placeholder="请选择优惠券"
          >
            <el-option
              class="optionBox"
              v-for="(item, index) in coupons"
              :key="index"
              :label="`￥${item.CouponDto.Money}`"
              :value="item.Id"
            >
              <div>
                <div>
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      border-bottom: 1px dashed #999;
                    "
                  >
                    <div>有效时间:{{ item.EndTime }}</div>
                    <div>￥{{ item.CouponDto.Money }}</div>
                  </div>
                  <div>
                    满{{ item.CouponDto.Threshold }}减{{ item.CouponDto.Money }}
                  </div>
                </div>
              </div>
            </el-option>
          </el-select>
        </div>
        <!-- 订单备注 -->
        <div class="TheOrder">
          <div style="color: #000; width: 20%">订单备注:</div>
          <div style="width: 80%">
            <el-input
              type="textarea"
              resize="none"
              :rows="2"
              placeholder="请输入内容"
              v-model.trim="textarea"
            ></el-input>
          </div>
        </div>
        <div class="TheOrder">
          <div style="width: 20%">快递方式:</div>
          <el-select
            style="width: 80%"
            v-model="CourierChoose"
            @change="orderChange"
            placeholder="请选择快递公司"
          >
            <el-option
              v-for="(item, index) in CourierArray"
              :key="index"
              :label="item.value"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </div>
        <div class="TheOrder">
          <div style="width: 20%">快递费:</div>
          <div style="width: 80%">￥{{ CourierFees }}</div>
        </div>
        <div class="TheOrder">
          <div style="width: 20%">付款方式</div>
          <el-select v-model="value" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="MakeOrder = false">取 消</el-button>
        <el-button type="primary" @click="orderObj">确定支付</el-button>
      </span>
    </el-dialog>
    <!-- 支付 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="400px"
      center
      :before-close="handleClose"
    >
      <span class="boxflex">
        <div style="margin-right: 0.5rem">支付密码:</div>
        <el-input
          style="width: 200px"
          :minlength="6"
          :maxlength="6"
          v-model="password"
          show-password
          placeholder="请输入支付密码"
        ></el-input>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="(dialogVisible = false), (password = '')"
          >取 消</el-button
        >
        <el-button type="primary" @click="orderPay">确 定</el-button>
      </span>
    </el-dialog>
    <instructions :isShow="isShow" :title="title" :goosHtml="goosHtml" />
    <!-- 评价 -->
    <el-dialog title="评价" :visible.sync="isEvaluation" width="50%" center>
      <div style="font-size: 1.1rem">
        <div>
          <div>评价:</div>
          <el-input
            style="width: 80%"
            type="textarea"
            :rows="3"
            resize="none"
            placeholder="请输入内容"
            v-model="ruleForm.content"
          >
          </el-input>
        </div>
        <div style="display: flex; margin-top: 1rem">
          <span>评价打分:</span>
          <el-rate v-model="ruleForm.star" show-text> </el-rate>
        </div>
        <el-upload
          style="margin-top: 1rem"
          :on-success="success"
          ref="my-upload"
          action="http://182.254.196.172:8026/api/upload/uploadFileOrder"
          list-type="picture-card"
        >
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{ file }">
            <img
              style="width: 100%"
              class="el-upload-list__item-thumbnail"
              :src="file.url"
              alt=""
            />
            <span class="el-upload-list__item-actions"> </span>
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelEvaluation">取 消</el-button>
        <el-button type="primary" @click="releaseDetermine">发布评论</el-button>
      </span>
    </el-dialog>
    <!-- 订单详情 -->
    <el-dialog
      title="订单详情"
      :visible.sync="isDetailsOrder"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        <div class="DetailsHeader">
          <div style="display: flex">
            <div style="margin-right: 1rem">
              联系人:{{ DetailsList.Consignee }}
            </div>
            <div>联系电话:{{ DetailsList.Phone }}</div>
          </div>
          <div style="margin-bottom: 10px">{{ DetailsList.Address }}</div>
        </div>
        <div class="details">
          <div>
            <div>交货尺寸:</div>
            <div>
              {{ Content.Det_BoardSize_W }}*{{ Content.Det_BoardSiez_H }}
            </div>
          </div>
          <div>
            <div>交货数量:</div>
            <div>{{ Content.Det_Num }}pcs</div>
          </div>
          <div>
            <div>set数:</div>
            <div>{{ Content.set }}</div>
          </div>
          <div>
            <div>下单型号:</div>
            <div>{{ DetailsList.Model }}</div>
          </div>
          <div>
            <div>面积:</div>
            <div>{{ Content.Area }}平方米</div>
          </div>
          <div>
            <div>拼板款数:</div>
            <div>{{ Content.Det_Pmodels }}</div>
          </div>
          <div>
            <div>板材类型:</div>
            <div>{{ Content.Det_BoardType }}</div>
          </div>
          <div>
            <div>板材供应商:</div>
            <div>{{ Content.Det_BoardSupplier }}</div>
          </div>
          <div>
            <div>成品外层铜厚:</div>
            <div>{{ Content.Det_Copper_out }}oz</div>
          </div>
          <div>
            <div>阻焊颜色:</div>
            <div>{{ Content.Det_ZHcolor }}</div>
          </div>
          <div>
            <div>阻焊覆盖:</div>
            <div>{{ Content.coverText }}</div>
          </div>
          <div>
            <div>表面处理:</div>
            <div>{{ Content.Det_Surface }}</div>
          </div>
          <div>
            <div>测试:</div>
            <div>{{ Content.Det_TestMethod }}</div>
          </div>
          <div>
            <div>确认生产稿:</div>
            <div>{{ Content.draftText }}</div>
          </div>
          <div>
            <div>最小线宽/线距:</div>
            <div>{{ Content.Det_LineSpacing }}mil</div>
          </div>
          <div>
            <div>最小孔径:</div>
            <div>{{ Content.aperture }}</div>
          </div>
          <div>
            <div>成型方式:</div>
            <div>{{ Content.Det_MouldManner }}</div>
          </div>
          <div>
            <div>订单号/物料编号:</div>
            <div>{{ Content.TorderNo }}</div>
          </div>
          <div>
            <div>收据/送货单:</div>
            <div>{{ Content.receiptText }}</div>
          </div>
          <div>
            <div>接受打叉板:</div>
            <div>{{ Content.isBreakBoard == 1 ? "接受" : "不接受" }}</div>
          </div>
          <div>
            <div>特殊工艺:</div>
            <div>
              {{ Content.Det_IsHalfHole == 0 ? "" : "半孔"
              }}{{ Content.Det_IsBGA == 0 ? "" : "BGA"
              }}{{ Content.Det_IsImp == 0 ? "" : "阻抗" }}
            </div>
          </div>
          <div>
            <div>接受标准:</div>
            <div>{{ Content.standardText }}</div>
          </div>
          <div>
            <div>发票信息:</div>
            <div>{{ Content.invoiceText }}</div>
          </div>
        </div>
        <div class="DetailsBody">
          <div>
            订单编号:
            <div>{{ DetailsList.OrderNo }}</div>
          </div>
          <div>
            工程联系人:
            <div>{{ DetailsList.EContact }}</div>
          </div>
          <div>
            工程联系电话:
            <div>{{ DetailsList.EContact_Phone }}</div>
          </div>
          <div>
            工程联系邮箱:
            <div>{{ DetailsList.EContact_Email }}</div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="isDetailsOrder = false">取 消</el-button>
        <el-button type="primary" @click="isDetailsOrder = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 设置支付密码 -->
    <el-dialog
      title="提示"
      :visible.sync="SetUpPay"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        <el-form label-position="left" label-width="80px" :model="pay">
          <el-form-item label="电话:">
            <el-input disabled v-model="pay.phone"></el-input>
          </el-form-item>
          <el-form-item label="验证码:">
            <el-input style="width: 70%" v-model="pay.verifyCode" />
            <span
              v-if="time == 0"
              @click="send"
              style="font-size: 0.8rem; color: #f00; width: 30%"
              >发送验证码</span
            >
            <span style="width: 30%; color: #f00" v-else
              >{{ time }}s重新发送</span
            >
          </el-form-item>
          <el-form-item label="密码:">
            <el-input
              :minlength="6"
              :maxlength="6"
              type="password"
              v-model="pay.password"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="(SetUpPay = false), (pay.password = '')"
          >取 消</el-button
        >
        <el-button type="primary" @click="setPassword">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 支付二维码显示 -->
    <el-dialog :visible.sync="isPay" width="20%" :before-close="handleClose">
      <div>
        <img style="width: 100%" :src="payImage" alt="" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delIsPay">取 消</el-button>
        <el-button type="primary" @click="delIsPay">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getOrderApi } from "../../api/http/order";
import { getUser } from "../../api/http/user";
import { getPay } from "../../api/http/pay";
import instructions from "../../components/box/instructions.vue";
import { getLoginApi } from "../../api/http/login";
import { address } from "../../api/http/address";
export default {
  components: {
    instructions,
  },
  props: {
    list: {
      type: Array,
    },
    setBillDetail: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      options: [
        { label: "余额支付", value: "1" },
        { label: "微信支付", value: "2" },
        { label: "支付宝支付", value: "3" },
      ],
      vftTime: null, //监听支付状态
      value: "1", //支付方式
      isPay: false, //支付显示
      payImage: "", //二维码显示
      time: 0, //发送验证码时间
      pay: {
        phone: "", //电话
        verifyCode: "", //验证码
        password: "", //密码
      },
      SetUpPay: false, //设置支付密码显示
      isDetailsOrder: false, //订单详情弹窗
      DetailsList: "", //订单详情列表
      ruleForm: {
        orderId: "",
        content: "",
        star: 0,
        imgDtos: [],
      }, //评论内容
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      isEvaluation: false, //评价
      title: "", //退货说明
      isShow: false, //弹窗显示
      goosHtml: "", //退货说明
      CourierChoose: "1", //快递方式
      CourierFees: 0, //快递费用
      textarea: "", //订单备注
      CourierArray: [
        { label: "1", value: "联昊通速运" },
        { label: "2", value: "速尔速运" },
        { label: "3", value: "顺丰速运" },
        { label: "4", value: "安能速运" },
      ], //快递数组
      MakeOrder: false, //参数详情
      region: 0, //优惠券
      coupons: [], //优惠卷数组
      orderItem: "", //选中对象
      Content: "", //选中对象的板材参数
      dialogVisible: false, //支付弹窗
      password: "", //支付密码
      orderData: [], //订单列表数组
      cancelTime: null, //定时器
    };
  },
  created() {},
  methods: {
    delIsPay() {
      this.isPay = false;
      this.isPay = false;
      clearInterval(this.vftTime);
      this.getInfo();
    },
    getInfo() {
      getUser.getUse().then((res) => {
        if (res.data.code == 200) {
          this.$store.commit("getUserInfo", res.data.data);
        }
      });
    },
    //
    setPassword() {
      if (this.pay.password.length == 6) {
        if (this.pay.verifyCode != "") {
          clearInterval(this.cancelTime);
          this.time = 0;
          let params = {
            phone: this.pay.phone,
            pwd: this.pay.password,
            verifyCode: this.pay.verifyCode,
          };
          getPay.setPwd(params).then((res) => {
            if (res.data.code == 200) {
              this.SetUpPay = false;
              this.$message({
                message: "密码设置成功！",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        } else {
          this.$message({
            message: "请输入验证码",
            type: "error",
          });
        }
      }
    },
    // 发送验证码
    send() {
      let params = {
        phone: this.pay.phone,
        type: 1,
      };
      let this_ = this;
      getPay.getSendsms(params).then((res) => {
        if (res.data.code == 200) {
          this_.time = 60;
          this.cancelTime = setInterval(() => {
            --this_.time;
            if (this_.time == 0) {
              clearInterval(this.cancelTime);
            }
          }, 1000);
          this.$message({
            message: "验证码发送成功！",
            type: "success",
          });
        } else {
          this.$message({
            message: "验证码发送失败！",
            type: "error",
          });
        }
      });
    },
    // 订单详情
    detailsOrde(e) {
      this.DetailsList = "";
      this.Content = "";
      getOrderApi.getOrderDetail({ id: e.Id }).then((res) => {
        if (res.data.code == 200) {
          this.DetailsList = res.data.data;
          this.Content = JSON.parse(this.DetailsList.OrderGoodsDtos[0].Content);
          this.isDetailsOrder = true;
        }
      });
    },
    // 评价弹窗取消
    cancelEvaluation() {
      this.ruleForm = {
        orderId: "",
        star: 0,
        content: "",
        imgDtos: [],
      };
      this.$refs["my-upload"].clearFiles();
      this.isEvaluation = false;
    },

    // 确定发布评论
    releaseDetermine() {
      if (this.ruleForm.content == "") {
        return this.$message({
          message: "请填写评价类容",
          type: "erroe",
        });
      }
      if (this.ruleForm.imgDtos.length == 0) {
        return this.$message({
          message: "请上传评价图片",
          type: "erroe",
        });
      }
      if (this.ruleForm.star == 0) {
        return this.$message({
          message: "请您为商品打分",
          type: "error",
        });
      }
      getOrderApi.orderEvaluation(this.ruleForm).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: "评价成功",
            type: "success",
          });
          this.setBillDetail();
          this.$refs["my-upload"].clearFiles();
          this.isEvaluation = false;
          this.ruleForm = {
            orderId: "",
            star: 0,
            content: "",
            imgDtos: [],
          };
        }
      });
    },
    // 图片上传
    success(res, file) {
      let imgUrl = {
        imgUrl: res[0],
      };
      this.ruleForm.imgDtos.push(imgUrl);
    },
    // 订单评价
    orderEvaluation(e) {
      this.ruleForm.orderId = e.Id;
      this.isEvaluation = true;
    },
    // 用户信息
    getUserInfo() {
      getUser.getUse().then((res) => {
        if (res.data.code == 200) {
          console.log(res);
          this.$store.commit("getUserInfo", res.data.data);
        }
      });
    },
    // 返单
    singleOrder(e) {
      let content = JSON.parse(e.OrderGoodsDtos[0].Content);
      this.$prompt("请输入返单数量", "返单数量", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          let params = {
            det_BoardSize_W: content.Det_BoardSiez_H,
            det_BoardSiez_H: content.Det_BoardSize_W,
            det_Num: value,
            det_Pmodels: content.Det_Pmodels,
            det_BoardType: content.Det_BoardType,
            det_BoardSupplier: content.Det_BoardSupplier,
            det_Layer: content.Det_Layer,
            det_BoardThickness: content.Det_BoardThickness,
            det_Copper_out: content.Det_Copper_out,
            det_Copper_in: content.Det_Copper_in,
            det_ZHcolor: content.Det_ZHcolor,
            det_TestMethod: content.Det_TestMethod,
            det_Testingjig: content.Det_Testingjig,
            det_Surface: content.Det_Surface,
            det_TestPrice: content.Det_TestPrice,
            det_TestNum: e.OrderGoodsDtos[0].Det_TestNum,
            det_Luo: e.OrderGoodsDtos[0].Det_Luo,
            det_PP: e.OrderGoodsDtos[0].Det_PP,
            det_Receipt: 0,
            det_LineSpacing: content.Det_LineSpacing,
            det_MouldManner: content.Det_MouldManner,
            det_mould: content.Det_mould,
            det_IsHalfHole: content.Det_IsHalfHole,
            det_IsImp: content.Det_IsImp,
            det_IsBGA: content.Det_IsBGA,
            det_Isinvoice: content.Det_Isinvoice,
            area:
              (content.Det_BoardSiez_H * content.Det_BoardSize_W * value) /
              10000,
            det_Hole: e.OrderGoodsDtos[0].Det_Hole,
          };
          getOrderApi.orderCalculate(params).then((res) => {
            this.$router.push({
              path: "/orderImmediately",
              query: {
                id: 3,
                orderFrom: e,
                orderOrd: res.data.data[0],
                orderValue: value,
              },
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    // 订单进度
    getProgress(e) {
      getOrderApi
        .getOrderProgress({ OrderNum: e.ProduceOrderNo })
        .then((res) => {
          if (res.data.data.length == 0) {
            this.$alert("当前订单未有工序请稍后查询", "订单进度");
          } else {
            this.$alert(
              `此订单已在 ${res.data.data[0].ToolName}工序 ${res.data.data[0].SCH_DATE} `,
              "订单进度"
            );
          }
        });
    },
    // 确认收货
    ConfirmGoods(e) {
      getOrderApi.getOrderConfirm({ orderId: e.Id }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: "确认收货成功！",
            type: "success",
          });
        }
        this.setBillDetail();
      });
    },
    // 退货说明
    returnGoos(e) {
      this.isShow = false;
      let params = {
        type: 8,
      };
      getOrderApi.getInfoList(params).then((res) => {
        if (res.data.code == 200) {
          this.goosHtml = res.data.data[0].Content;
          this.title = "退货说明";
          this.isShow = true;
        }
      });
    },
    // 订单进度
    orderProgress(e) {
      getOrderApi.getOrderExpress({ orderid: e.Id }).then((res) => {
        this.$alert(
          `<p><i>订单编号:</i>${e.OrderNo}</p>
          <p>物流名称:${e.ExpressCompany}</p>
          <p>快递编号:${e.ExpressNo}</p>
          <p>收件人:${e.Consignee}</p>
          <p>联系电话:${e.Phone}</p>
          <p>收货地址:${e.Address}</p>
          <p>${res.data.data.message}</p>`,
          "物流详情",
          {
            dangerouslyUseHTMLString: true,
          }
        );
      });
    },
    // 确认支付
    orderPay() {
      let expressCompany = "";
      for (let i = 0; i < this.CourierArray.length; i++) {
        if (this.CourierChoose == this.CourierArray[i].label) {
          expressCompany = this.CourierArray[i].value;
        }
      }
      let params = {
        orderId: this.orderItem.Id,
        password: this.password,
        payType: 2,
        userCouponId: this.region,
        remark: this.textarea,
        freight: this.CourierFees,
        expressCompany,
      };
      getOrderApi.getPay(params).then((res) => {
        this.MakeOrder = false;
        if (res.data.code == 200) {
          this.getUserInfo();
          this.$message({
            message: "支付成功！！",
            type: "success",
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
        this.setBillDetail();
        this.dialogVisible = false;
      });
    },
    // 取消订单
    confirm(e) {
      let params = {
        orderId: e,
        remark: "",
      };
      getOrderApi.getOrderCancel(params).then((res) => {
        if (res.data.code == 200) {
          this.setBillDetail();
          this.$message({
            message: "取消成功",
            type: "success",
          });
        } else {
          this.$message({
            message: "取消失败",
            type: "error",
          });
        }
      });
    },
    // 快递费计算
    orderChange(e) {
      let obj = {
        Det_BoardThickness: this.Content.Det_BoardThickness,
        Area: this.Content.Area,
        kdtype: this.CourierChoose,
        Province: this.orderItem.Province,
      };

      address
        .calculateFreight(obj)
        .then((res) => {
          let { data } = res.data;
          console.log(res);
          this.CourierFees = data;
        })
        .catch();
    },
    // 计价显示
    orderObj() {
      let this_ = this;
      if (this.value == "1") {
        getLoginApi
          .getUserInfo()
          .then((res) => {
            if (res.data.data.PayPwd == "") {
              this.$confirm("请先设置支付密码！", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  this_.pay.phone = res.data.data.Phone;
                  this_.MakeOrder = false;
                  this_.SetUpPay = true;
                })
                .catch(() => {});
            } else {
              this.dialogVisible = true;
            }
          })
          .catch((err) => {});
      } else if (this.value == "2") {
        this.payImage = "";
        let expressCompany = "";
        for (let i = 0; i < this.CourierArray.length; i++) {
          if (this.CourierChoose == this.CourierArray[i].label) {
            expressCompany = this.CourierArray[i].value;
          }
        }
        let params = {
          orderId: this.orderItem.Id,
          payType: 2,
          userCouponId: this.region,
          remark: this.textarea,
          freight: this.CourierFees,
          expressCompany,
        };
        getPay.setWeChatPay(params).then((res) => {
          if (res.data.code == 200) {
            this_.MakeOrder = false;
            this_.isPay = true;
            this_.payImage =
              "https://api.pwmqr.com/qrcode/create/?url=" + res.data.data;

            this.vftTime = setInterval(() => {
              getPay.setWPay(this.orderItem.Id).then((res) => {
                if (res.data.code == 200) {
                  clearInterval(this.vftTime);
                  this.isPay = false;
                  this.setBillDetail;
                }
              });
            }, 1000);
          } else if (res.data.code == 201) {
            this.MakeOrder = false;
            this.setBillDetail;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      } else if (this.value == "3") {
        let expressCompany = "";
        for (let i = 0; i < this.CourierArray.length; i++) {
          if (this.CourierChoose == this.CourierArray[i].label) {
            expressCompany = this.CourierArray[i].value;
          }
        }
        let params = {
          orderId: this.orderItem.Id,
          payType: 2,
          userCouponId: this.region,
          remark: this.textarea,
          freight: this.CourierFees,
          expressCompany,
        };
        getPay.setAlipayPay(params).then((res) => {
          if (res.data.code == 200) {
            this.$router.push({
              path: "/alipay",
              query: { htmls: res.data.data },
            });
          } else if (res.data.code == 201) {
            this.MakeOrder = false;
            this.setBillDetail;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      }
      this.getInfo();
    },
    // 叉号取消
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          clearInterval(this.vftTime);
          done();
        })
        .catch((_) => {});
    },
    // 支付
    orderLisr(e) {
      this.MakeOrder = true;
      this.orderItem = e;
      this.Content = JSON.parse(e.OrderGoodsDtos[0].Content);
      let params = {
        orderid: e.Id,
        isexpire: false,
        isused: false,
        page: 1,
        size: 30,
      };
      getOrderApi.getCouponMylist(params).then((res) => {
        if (res.data.code == 200) {
          if (res.data.data.length != 0) {
            this.coupons = res.data.data;
            this.region = this.coupons[0].Id;
          }
        }
        this.orderChange();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.DetailsBody {
  margin-top: 0.5rem;
  border: 1px solid #999;

  border-radius: 5px;
  div {
    margin-top: 5px;
    justify-content: space-between;

    display: flex;
    div {
      text-align: left;
    }
  }
}
.DetailsHeader {
  border-bottom: 0.1rem solid #999;
  text-align: left;
  div {
    margin-top: 5px;
  }
}
.TheOrder {
  margin-top: 1rem;
  display: flex;
  align-items: center;
}
.optionBox {
  height: 80px;
  .itemBox {
    margin: 5px;
    padding: 5px;
    height: 70px;
    background: #fff;
  }
}
.details {
  height: 300px;
  overflow-y: scroll;

  div {
    display: flex;
    justify-content: space-between;
    div {
      padding: 5px;
    }
  }
}
.box {
  border-bottom: 0.1rem solid #999;
}
.boxflex {
  display: flex;
  align-items: center;
  justify-content: center;
}
.flexBox {
  display: flex;

  justify-content: space-evenly;
}
.memberCenter {
  background-color: #fff;
  .OrderDynamic {
    width: 90%;
    margin: auto;
    margin-top: 1rem;
    border: 1px solid #eee;
  }
  .tabberBox {
    width: 90%;
    margin: auto;
    margin-top: 1rem;
    .tabelHeader {
      background-color: #eee;
      display: flex;
      div {
        flex: 1;
        padding: 5px;
        text-align: center;
      }
    }
    .tabelFrom {
      display: flex;
      margin-top: 1rem;
      box-shadow: 0 5px 5px #999;
      border-bottom: 1px solid #999;
      padding-bottom: 10px;
      height: 50px;
      align-items: center;
      div {
        flex: 1;
        text-align: center;
        padding: 5px;
      }
      img {
        width: 50px;
        height: 50px;
        border-radius: 5px;
      }
    }
  }
}

.flexox {
  display: flex;
  justify-content: space-evenly;
  span {
    display: block;
    margin-right: 5px;
  }
}
.font {
  font-size: 1.5rem;
  margin: auto;
  text-align: center;
  margin-top: 2rem;
}
.fromBox {
  height: 400px;
  overflow-y: scroll;
}
.flexBox {
  display: flex;

  align-items: center;
  margin-top: 1rem;
  padding: 10px;
  background: #fff;
  box-shadow: 0 5px 5px #999;
  div {
    flex: 1;
    text-align: center;
    img {
      width: 50px;
      height: 50px;
      border-radius: 5px;
    }
  }
}
.formHeader {
  display: flex;
  background-color: #eee;
  padding: 10px;
  z-index: 3;
  box-shadow: 0 5px 5px 5px #999;
  div {
    flex: 1;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/box/fromBox.vue